export default "__VITE_ASSET__CCmUMkjQ__"